import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { NotificationReportPage } from "../components/notifications/NotificationReportPage";
import { useAuth } from "../lib/auth/hooks";
import { requireAuth } from "../lib/auth/route-protection";
import { useI18n } from "../lib/i18n";
import { AuthTransitionScreen } from "../../ui/components/AuthTransitionScreen";

export const Route = createFileRoute("/profile_/notification-report")({
  beforeLoad: requireAuth(),
  component: ProfileNotificationReportRoute,
});

function ProfileNotificationReportRoute() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useI18n();
  if (!user) return <AuthTransitionScreen variant="fill" message={t("pro.profile.loading")} />;
  return (
    <NotificationReportPage
      userId={user.id}
      backLabel={t("pro.notifications.report.backToProfile")}
      onBack={() => navigate({ to: "/profile" })}
    />
  );
}
